// src/pages/Home.jsx

import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import { Link } from "react-router-dom";

import CalculadoraRiders from "../components/CalculadoraRiders";

import {
  getDashboardHomeVentas,
} from "../helpers/rutaVentas";

import "../css/home.css";

/* ========================================================================
   ICONOS
======================================================================== */

const IconChart = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M4 19V9M10 19V5M16 19v-7M22 19H2"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconDollar = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <circle
      cx="12"
      cy="12"
      r="9"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M15 8.5c-.8-.7-1.8-1-3-1-1.7 0-3 .8-3 2s1.2 1.8 3 2.2 3 .9 3 2.3-1.3 2.5-3.2 2.5c-1.3 0-2.5-.4-3.3-1.2M12 5.5v13"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const IconClock = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <circle
      cx="12"
      cy="12"
      r="9"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M12 7v5l3 2"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconWarning = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M12 3 2.8 19h18.4L12 3Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M12 9v4M12 17h.01"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const IconUsers = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M16 20v-1.5A3.5 3.5 0 0 0 12.5 15h-5A3.5 3.5 0 0 0 4 18.5V20"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle
      cx="10"
      cy="8"
      r="3"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M17 11a3 3 0 0 0 0-6M18.5 15.5A3.5 3.5 0 0 1 21 18.8V20"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const IconCard = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <rect
      x="3"
      y="5"
      width="18"
      height="14"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M3 10h18M7 15h4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const IconDocument = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M7 3h7l4 4v14H7V3Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M14 3v5h4M10 13h5M10 17h5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const IconPlus = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <circle
      cx="12"
      cy="12"
      r="9"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M12 8v8M8 12h8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const IconLightning = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M13 2 4 14h7l-1 8 10-13h-7l1-7Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconCalculator = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <rect
      x="5"
      y="2"
      width="14"
      height="20"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
    />

    <rect
      x="8"
      y="5"
      width="8"
      height="4"
      rx="1"
      stroke="currentColor"
      strokeWidth="2"
    />

    <path
      d="M8 13h1M12 13h1M16 13h.01M8 17h1M12 17h1M16 17h.01"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const IconArrow = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="m9 6 6 6-6 6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* ========================================================================
   HELPERS VISUALES
======================================================================== */

const moneyUSD = (value) =>
  new Intl.NumberFormat(
    "en-US",
    {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
    }
  ).format(Number(value || 0));

const moneyUSD2 = (value) =>
  new Intl.NumberFormat(
    "en-US",
    {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }
  ).format(Number(value || 0));

const formatearFechaCorta = (
  value
) => {
  if (!value) return "";

  const fecha =
    new Date(value);

  if (
    Number.isNaN(
      fecha.getTime()
    )
  ) {
    return "";
  }

  return fecha.toLocaleDateString(
    "es-AR",
    {
      day: "2-digit",
      month: "short",
    }
  );
};

const getNombreUsuario = () => {
  try {
    const raw =
      localStorage.getItem(
        "usuario"
      ) ||
      localStorage.getItem(
        "user"
      );

    if (!raw) return "";

    const usuario =
      JSON.parse(raw);

    if (
      typeof usuario ===
      "string"
    ) {
      return usuario;
    }

    return (
      usuario?.nombres ||
      usuario?.nombre ||
      usuario?.email ||
      ""
    );
  } catch {
    return "";
  }
};

const nombrePeriodo = (
  periodo
) => {
  if (periodo === "HOY") {
    return "hoy";
  }

  if (
    periodo === "MES"
  ) {
    return "mes anterior";
  }

  return "semana anterior";
};

/* ========================================================================
   GRÁFICO SVG
======================================================================== */

const GraficoRendimiento = ({
  datos = [],
}) => {
  const puntos =
    Array.isArray(datos)
      ? datos
      : [];

  if (
    puntos.length === 0
  ) {
    return (
      <div className="dash-chart-empty">
        Sin datos para este período.
      </div>
    );
  }

  const width = 700;
  const height = 220;

  const paddingX = 30;
  const paddingTop = 25;
  const paddingBottom = 35;

  const maxValor =
    Math.max(
      ...puntos.map(
        (item) =>
          Number(
            item.montoUSD || 0
          )
      ),
      1
    );

  const usableWidth =
    width -
    paddingX * 2;

  const usableHeight =
    height -
    paddingTop -
    paddingBottom;

  const coords =
    puntos.map(
      (item, index) => {
        const x =
          puntos.length === 1
            ? width / 2
            : paddingX +
              (
                index /
                (
                  puntos.length -
                  1
                )
              ) *
                usableWidth;

        const y =
          paddingTop +
          usableHeight -
          (
            Number(
              item.montoUSD ||
                0
            ) /
            maxValor
          ) *
            usableHeight;

        return {
          x,
          y,
          ...item,
        };
      }
    );

  const path =
    coords
      .map(
        (punto, index) =>
          `${index === 0 ? "M" : "L"} ${punto.x} ${punto.y}`
      )
      .join(" ");

  const area =
    coords.length
      ? `${path} L ${
          coords[
            coords.length -
              1
          ].x
        } ${
          height -
          paddingBottom
        } L ${
          coords[0].x
        } ${
          height -
          paddingBottom
        } Z`
      : "";

  const formatterDia =
    new Intl.DateTimeFormat(
      "es-AR",
      {
        weekday: "short",
      }
    );

  return (
    <div className="dash-chart-wrap">
      <svg
        className="dash-chart-svg"
        viewBox={`0 0 ${width} ${height}`}
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient
            id="dashAreaGradient"
            x1="0"
            y1="0"
            x2="0"
            y2="1"
          >
            <stop
              offset="0%"
              stopColor="currentColor"
              stopOpacity="0.18"
            />
            <stop
              offset="100%"
              stopColor="currentColor"
              stopOpacity="0.02"
            />
          </linearGradient>
        </defs>

        {[0, 1, 2, 3].map(
          (linea) => {
            const y =
              paddingTop +
              (
                usableHeight /
                3
              ) *
                linea;

            return (
              <line
                key={linea}
                x1={paddingX}
                x2={
                  width -
                  paddingX
                }
                y1={y}
                y2={y}
                className="dash-chart-grid"
              />
            );
          }
        )}

        <path
          d={area}
          className="dash-chart-area"
        />

        <path
          d={path}
          className="dash-chart-line"
        />

        {coords.map(
          (punto, index) => (
            <circle
              key={
                punto.fecha ||
                index
              }
              cx={punto.x}
              cy={punto.y}
              r="5"
              className="dash-chart-point"
            />
          )
        )}
      </svg>

      <div className="dash-chart-labels">
        {puntos.map(
          (item, index) => {
            const fecha =
              new Date(
                `${item.fecha}T12:00:00`
              );

            const label =
              Number.isNaN(
                fecha.getTime()
              )
                ? ""
                : formatterDia
                    .format(
                      fecha
                    )
                    .replace(
                      ".",
                      ""
                    );

            return (
              <span
                key={
                  item.fecha ||
                  index
                }
              >
                {label}
              </span>
            );
          }
        )}
      </div>
    </div>
  );
};

/* ========================================================================
   COMPONENTE
======================================================================== */

const Home = () => {
  const [
    periodo,
    setPeriodo,
  ] = useState("SEMANA");

  const [
    dashboard,
    setDashboard,
  ] = useState(null);

  const [
    loading,
    setLoading,
  ] = useState(true);

  const [
    error,
    setError,
  ] = useState("");

  const [
    showCalculadora,
    setShowCalculadora,
  ] = useState(false);

  useEffect(() => {
    const controller =
      new AbortController();

    const cargar = async () => {
      setLoading(true);
      setError("");

      try {
        const data =
          await getDashboardHomeVentas(
            {
              periodo,
              signal:
                controller.signal,
            }
          );

        setDashboard(
          data
        );
      } catch (e) {
        if (
          e?.name ===
            "CanceledError" ||
          e?.name ===
            "AbortError"
        ) {
          return;
        }

        console.error(
          "Error cargando dashboard:",
          e
        );

        setError(
          e?.response?.data
            ?.error ||
            e?.message ||
            "No se pudo cargar el dashboard."
        );
      } finally {
        if (
          !controller
            .signal
            .aborted
        ) {
          setLoading(
            false
          );
        }
      }
    };

    cargar();

    return () => {
      controller.abort();
    };
  }, [periodo]);

  useEffect(() => {
    if (!showCalculadora) {
      return undefined;
    }

    const overflowAnterior =
      document.body.style.overflow;

    document.body.style.overflow =
      "hidden";

    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setShowCalculadora(false);
      }
    };

    window.addEventListener(
      "keydown",
      handleKeyDown
    );

    return () => {
      document.body.style.overflow =
        overflowAnterior;

      window.removeEventListener(
        "keydown",
        handleKeyDown
      );
    };
  }, [showCalculadora]);

  const resumen =
    dashboard?.resumen || {};

  const alertas =
    dashboard?.alertas || {};

  const alcance =
    dashboard?.alcance || {};

  const nombreUsuario =
    getNombreUsuario();

  const esAdmin =
    alcance.tipo ===
    "TODAS";

  const esManager =
    alcance.tipo ===
    "SEDE";

  const titulo =
    esAdmin
      ? "Dashboard General"
      : esManager
      ? `Dashboard ${alcance.sede || ""}`
      : "Mi Dashboard";

  const subtitulo =
    esAdmin
      ? "Resumen comercial consolidado de todas las sedes."
      : esManager
      ? `Resumen comercial y operativo de la sede ${
          alcance.sede ||
          ""
        }.`
      : "Resumen comercial del vendedor.";

  const badge =
    esAdmin
      ? "Vista General"
      : esManager
      ? `Vista ${alcance.sede || "Sede"}`
      : "Vista Vendedor";

  const variacionPrincipal =
    resumen
      .variacionMontoPct;

  const resumenVendedores =
    useMemo(
      () =>
        Array.isArray(
          dashboard
            ?.resumenVendedores
        )
          ? dashboard
              .resumenVendedores
              .slice(0, 5)
          : [],
      [
        dashboard
          ?.resumenVendedores,
      ]
    );

  const acciones =
    useMemo(() => {
      const base = [
        {
          label:
            "Ventas",
          to: "/Ventas",
          icon:
            <IconDocument />,
        },
        {
          label:
            "Venta rápida",
          to: "/VentaRapida",
          icon:
            <IconLightning />,
        },
      ];

      if (
        esManager
      ) {
        return [
          ...base,
          {
            label:
              "Clientes",
            to: "/Clientes",
            icon:
              <IconUsers />,
          },
          {
            label:
              "Informes",
            to: "/informeventas",
            icon:
              <IconChart />,
          },
        ];
      }

      return [
        ...base,
        {
          label:
            "Clientes",
          to: "/Clientes",
          icon:
            <IconUsers />,
        },
        {
          label:
            "Informes",
          to: "/HomeImpresion",
          icon:
            <IconChart />,
        },
      ];
    }, [
      esManager,
    ]);

  return (
    <main className="dash-home">
      <section className="dash-container">

        {/* =====================================================
            CABECERA
        ====================================================== */}

        <header className="dash-header">
          <div>
            {nombreUsuario && (
              <div className="dash-greeting">
                Hola,{" "}
                <strong>
                  {
                    nombreUsuario.split(
                      " "
                    )[0]
                  }
                </strong>
              </div>
            )}

            <div className="dash-title-row">
              <div>
                <h1>
                  {titulo}
                </h1>

                <p>
                  {subtitulo}
                </p>
              </div>

              <div className="dash-header-tools">
                <span className="dash-role-badge">
                  {badge}
                </span>

                <button
                  type="button"
                  className="dash-calculator-pill"
                  onClick={() =>
                    setShowCalculadora(true)
                  }
                >
                  <span className="dash-calculator-pill-icon">
                    <IconCalculator />
                  </span>

                  <span>
                    Calculadora
                  </span>
                </button>
              </div>
            </div>
          </div>

        </header>

        {/* =====================================================
            ACCIONES RÁPIDAS — ARRIBA
        ====================================================== */}

        {dashboard && (
          <section className="dash-actions-section dash-actions-top">
            <div className="dash-section-header dash-actions-title">
              <div>
                <span className="dash-section-icon">
                  <IconLightning />
                </span>

                <h2>
                  Acciones rápidas
                </h2>
              </div>
            </div>

            <div className="dash-actions-grid">
              {acciones.map(
                (
                  accion,
                  index
                ) => (
                  <Link
                    key={
                      accion.to +
                      index
                    }
                    to={
                      accion.to
                    }
                    className={`dash-action dash-action-tone-${
                      index + 1
                    }`}
                  >
                    <span className="dash-action-icon">
                      {
                        accion.icon
                      }
                    </span>

                    <strong>
                      {
                        accion.label
                      }
                    </strong>
                  </Link>
                )
              )}
            </div>
          </section>
        )}

        {/* =====================================================
            PERÍODO
        ====================================================== */}

        <div className="dash-period-row">
          <div className="dash-period-selector">
            {[
              "HOY",
              "SEMANA",
              "MES",
            ].map(
              (item) => (
                <button
                  key={item}
                  type="button"
                  className={
                    periodo ===
                    item
                      ? "active"
                      : ""
                  }
                  onClick={() =>
                    setPeriodo(
                      item
                    )
                  }
                >
                  {item ===
                  "HOY"
                    ? "Hoy"
                    : item ===
                      "SEMANA"
                    ? "Semana"
                    : "Mes"}
                </button>
              )
            )}
          </div>
        </div>

        {/* =====================================================
            LOADING
        ====================================================== */}

        {loading && (
          <div className="dash-loading">
            <div className="dash-spinner" />

            <span>
              Cargando dashboard...
            </span>
          </div>
        )}

        {/* =====================================================
            ERROR
        ====================================================== */}

        {!loading &&
          error && (
            <div className="dash-error">
              {error}
            </div>
          )}

        {!loading &&
          !error &&
          dashboard && (
            <>
              {/* ===============================================
                  KPIs
              ================================================ */}

              <section className="dash-kpi-grid">
                <article className="dash-kpi dash-kpi-blue">
                  <div className="dash-kpi-icon">
                    <IconChart />
                  </div>

                  <div className="dash-kpi-content">
                    <span>
                      {esAdmin
                        ? "Ventas"
                        : esManager
                        ? "Ventas sede"
                        : "Mis ventas"}
                    </span>

                    <strong>
                      {
                        resumen.ventas ||
                        0
                      }
                    </strong>

                    {resumen
                      .variacionVentasPct !==
                      null &&
                      resumen
                        .variacionVentasPct !==
                        undefined && (
                        <small
                          className={
                            resumen
                              .variacionVentasPct >=
                            0
                              ? "positive"
                              : "negative"
                          }
                        >
                          {resumen
                            .variacionVentasPct >=
                          0
                            ? "↑"
                            : "↓"}{" "}
                          {Math.abs(
                            resumen
                              .variacionVentasPct
                          )}
                          % vs{" "}
                          {nombrePeriodo(
                            periodo
                          )}
                        </small>
                      )}
                  </div>
                </article>

                <article className="dash-kpi dash-kpi-green">
                  <div className="dash-kpi-icon">
                    <IconDollar />
                  </div>

                  <div className="dash-kpi-content">
                    <span>
                      Monto vendido
                    </span>

                    <strong className="dash-money">
                      {moneyUSD(
                        resumen
                          .montoVendidoUSD
                      )}
                    </strong>

                    {variacionPrincipal !==
                      null &&
                      variacionPrincipal !==
                        undefined && (
                        <small
                          className={
                            variacionPrincipal >=
                            0
                              ? "positive"
                              : "negative"
                          }
                        >
                          {variacionPrincipal >=
                          0
                            ? "↑"
                            : "↓"}{" "}
                          {Math.abs(
                            variacionPrincipal
                          )}
                          % vs{" "}
                          {nombrePeriodo(
                            periodo
                          )}
                        </small>
                      )}
                  </div>
                </article>

                <article className="dash-kpi dash-kpi-yellow">
                  <div className="dash-kpi-icon">
                    <IconClock />
                  </div>

                  <div className="dash-kpi-content">
                    <span>
                      Pendientes
                    </span>

                    <strong className="dash-money">
                      {moneyUSD(
                        resumen
                          .saldoPendienteUSD
                      )}
                    </strong>

                    <small>
                      Saldo por completar
                    </small>
                  </div>
                </article>

                <article className="dash-kpi dash-kpi-red">
                  <div className="dash-kpi-icon">
                    <IconWarning />
                  </div>

                  <div className="dash-kpi-content">
                    <span>
                      Incompletas
                    </span>

                    <strong>
                      {
                        resumen.incompletas ||
                        0
                      }
                    </strong>

                    <small>
                      Datos pendientes
                    </small>
                  </div>
                </article>
              </section>

              {/* ===============================================
                  ALERTAS
              ================================================ */}

              <section className="dash-panel">
                <div className="dash-section-header">
                  <div>
                    <span className="dash-section-icon">
                      <IconWarning />
                    </span>

                    <h2>
                      Atención
                    </h2>
                  </div>

                  <span className="dash-section-caption">
                    Pendientes actuales
                  </span>
                </div>

                <div className="dash-alert-grid">
                  <article className="dash-alert dash-alert-red">
                    <div className="dash-alert-icon">
                      <IconWarning />
                    </div>

                    <div>
                      <strong>
                        Faltan datos de Cuba
                      </strong>

                      <span>
                        {
                          alertas.faltanDatosCuba ||
                          0
                        }{" "}
                        ventas
                      </span>
                    </div>

                    <div className="dash-alert-arrow">
                      <IconArrow />
                    </div>
                  </article>

                  <article className="dash-alert dash-alert-blue">
                    <div className="dash-alert-icon">
                      <IconUsers />
                    </div>

                    <div>
                      <strong>
                        Seguimientos pendientes
                      </strong>

                      <span>
                        {
                          alertas.seguimientosPendientes ||
                          0
                        }{" "}
                        clientes
                      </span>
                    </div>

                    <div className="dash-alert-arrow">
                      <IconArrow />
                    </div>
                  </article>

                  <article className="dash-alert dash-alert-yellow">
                    <div className="dash-alert-icon">
                      <IconCard />
                    </div>

                    <div>
                      <strong>
                        Pagos por acreditar
                      </strong>

                      <span>
                        {
                          alertas.pagosPorAcreditar ||
                          0
                        }{" "}
                        pagos
                      </span>
                    </div>

                    <div className="dash-alert-arrow">
                      <IconArrow />
                    </div>
                  </article>

                  <article className="dash-alert dash-alert-purple">
                    <div className="dash-alert-icon">
                      <IconDocument />
                    </div>

                    <div>
                      <strong>
                        Ventas parciales
                      </strong>

                      <span>
                        {
                          alertas.ventasParciales ||
                          0
                        }{" "}
                        ventas
                      </span>
                    </div>

                    <div className="dash-alert-arrow">
                      <IconArrow />
                    </div>
                  </article>
                </div>
              </section>

              {/* ===============================================
                  RENDIMIENTO + VENDEDOR/SEDES
              ================================================ */}

              <section className="dash-main-grid">
                <article className="dash-panel dash-performance">
                  <div className="dash-section-header">
                    <div>
                      <span className="dash-section-icon">
                        <IconChart />
                      </span>

                      <h2>
                        {esAdmin
                          ? "Rendimiento general"
                          : esManager
                          ? `Rendimiento ${alcance.sede || ""}`
                          : "Mi rendimiento"}
                      </h2>
                    </div>

                    {variacionPrincipal !==
                      null &&
                      variacionPrincipal !==
                        undefined && (
                        <span
                          className={`dash-trend-badge ${
                            variacionPrincipal >=
                            0
                              ? "positive"
                              : "negative"
                          }`}
                        >
                          {variacionPrincipal >=
                          0
                            ? "↑"
                            : "↓"}{" "}
                          {Math.abs(
                            variacionPrincipal
                          )}
                          %
                        </span>
                      )}
                  </div>

                  <GraficoRendimiento
                    datos={
                      dashboard.rendimiento
                    }
                  />
                </article>

                {(esAdmin ||
                  esManager) && (
                  <article className="dash-panel dash-ranking">
                    <div className="dash-section-header">
                      <div>
                        <span className="dash-section-icon">
                          <IconUsers />
                        </span>

                        <h2>
                          Vendedores
                        </h2>
                      </div>
                    </div>

                    <div className="dash-ranking-list">
                      {resumenVendedores.length ===
                      0 ? (
                        <div className="dash-empty">
                          Sin ventas en el período.
                        </div>
                      ) : (
                        resumenVendedores.map(
                          (
                            vendedor,
                            index
                          ) => (
                            <div
                              className="dash-ranking-row"
                              key={
                                vendedor.vendedorId ||
                                index
                              }
                            >
                              <span className="dash-ranking-number">
                                {index +
                                  1}
                              </span>

                              <div className="dash-ranking-user">
                                <strong>
                                  {
                                    vendedor.nombre
                                  }
                                </strong>

                                <span>
                                  {
                                    vendedor.ventas
                                  }{" "}
                                  ventas
                                </span>
                              </div>

                              <strong className="dash-ranking-money">
                                {moneyUSD(
                                  vendedor.montoUSD
                                )}
                              </strong>
                            </div>
                          )
                        )
                      )}
                    </div>
                  </article>
                )}
              </section>

              {/* ===============================================
                  ÚLTIMAS VENTAS
              ================================================ */}

              <section className="dash-panel">
                <div className="dash-section-header">
                  <div>
                    <span className="dash-section-icon">
                      <IconClock />
                    </span>

                    <h2>
                      Últimas ventas
                    </h2>
                  </div>

                  <Link
                    to="/Ventas"
                    className="dash-view-all"
                  >
                    Ver todas
                  </Link>
                </div>

                <div className="dash-sales-list">
                  {dashboard
                    .ultimasVentas
                    .length ===
                  0 ? (
                    <div className="dash-empty">
                      No hay ventas para este período.
                    </div>
                  ) : (
                    dashboard.ultimasVentas
                      .slice(0, 3)
                      .map(
                      (
                        venta
                      ) => {
                        const estado =
                          String(
                            venta.estadoPago ||
                              "PENDIENTE"
                          ).toUpperCase();

                        return (
                          <Link
                            key={
                              venta.ventaId
                            }
                            to="/Ventas"
                            className="dash-sale-row"
                          >
                            <div className="dash-sale-product">
                              <div className="dash-sale-icon">
                                <IconDocument />
                              </div>

                              <div>
                                <strong>
                                  {
                                    venta.producto
                                  }
                                </strong>

                                <span>
                                  Venta N°{" "}
                                  {
                                    venta.nroventa
                                  }{" "}
                                  ·{" "}
                                  {formatearFechaCorta(
                                    venta.fecha
                                  )}
                                </span>
                              </div>
                            </div>

                            <div className="dash-sale-right">
                              <strong>
                                {moneyUSD2(
                                  venta.totalUSD
                                )}
                              </strong>

                              <span
                                className={`dash-status dash-status-${estado.toLowerCase()}`}
                              >
                                {estado ===
                                "PAGADO"
                                  ? "Pagado"
                                  : estado ===
                                    "PARCIAL"
                                  ? "Parcial"
                                  : "Pendiente"}
                              </span>

                              <div className="dash-sale-chevron">
                                <IconArrow />
                              </div>
                            </div>
                          </Link>
                        );
                      }
                    )
                  )}
                </div>
              </section>

            </>
          )}
      </section>

      {showCalculadora && (
        <div
          className="dash-calculator-overlay"
          onMouseDown={() =>
            setShowCalculadora(false)
          }
        >
          <div
            className="dash-calculator-modal"
            role="dialog"
            aria-modal="true"
            aria-label="Calculadora Riders"
            onMouseDown={(e) =>
              e.stopPropagation()
            }
          >
            <CalculadoraRiders
              onCerrar={() =>
                setShowCalculadora(false)
              }
            />
          </div>
        </div>
      )}
    </main>
  );
};

export default Home;